import { MenuItem, Select } from "@mui/material";
import { useFormikContext } from "formik";
import { ConfigTabState } from "../types";
import { BalancingGroup, balancingGroupLabel } from "../balancingGroup";
import { OutlinedSection } from "./outlinedSection";

/**
 * Generator or retailer balancing group for the algo, framed like the trade
 * start and end beside it in the Advanced section.
 *
 * Editable for new algos only: the group is chosen at creation and an update
 * echoes the algo's existing one back unchanged (see
 * `withEchoedBalancingGroup`), so when editing it is `disabled` and shows the
 * algo's group for context. A pick lasts for this one algo only — the next
 * form starts back on `DEFAULT_BALANCING_GROUP`.
 */
export const BalancingGroupField = (props: { disabled?: boolean }) => {
  const { values, setFieldValue } = useFormikContext<ConfigTabState>();

  return (
    <OutlinedSection label="Balancing group">
      <Select<BalancingGroup | "">
        size="small"
        fullWidth
        disabled={props.disabled}
        // "" rather than undefined keeps the Select controlled. A new algo
        // always has a group, so it only shows for an existing algo created
        // before the field existed, or a bulk selection that disagrees.
        value={values.balancing_group ?? ""}
        displayEmpty
        renderValue={(v) => (v === "" ? "—" : balancingGroupLabel[v])}
        onChange={(event) =>
          setFieldValue("balancing_group", event.target.value as BalancingGroup)
        }
        sx={{ fontSize: 12 }}
      >
        {Object.values(BalancingGroup).map((group) => (
          <MenuItem key={group} value={group} sx={{ fontSize: 12 }}>
            {balancingGroupLabel[group]}
          </MenuItem>
        ))}
      </Select>
    </OutlinedSection>
  );
};
